<p>membership-detail works!</p>
